import {apiGet} from './client';

export function getPlans() {
    return apiGet('/celebs/plans');
}
